import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzTableModule } from 'ng-zorro-antd/table';
import { MmTableDirective } from './paged-table.directive';
import { PagedTableComponent } from './paged-table/paged-table.component';
import { PagedTableColumnComponent } from './paged-table-column/paged-table-column.component'

import { TotalTemplateComponent } from './total-template/total-template.component';
import { ExtensionManagementComponent } from './extension-management/extension-management.component';

@NgModule({
  declarations: [MmTableDirective, PagedTableComponent, PagedTableColumnComponent, TotalTemplateComponent, ExtensionManagementComponent],
  imports: [
    CommonModule,
    NzTableModule
  ],
  exports: [MmTableDirective, NzTableModule, PagedTableComponent, PagedTableColumnComponent]
})
export class MmTableModule {






}
